import '@hotwired/turbo-rails'; // ✅ Turbo replaces Turbolinks
import '@rails/activestorage';
import '@rails/ujs';

import './channels';

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';

import './styles/application.scss';

import feather from 'feather-icons';

// Make Bootstrap available globally
window.bootstrap = bootstrap;

// Function to initialize feather icons with error handling
function initializeFeatherIcons() {
  try {
    console.log('Initializing Feather icons...');
    feather.replace();

    // Check if icons were actually replaced
    const iconElements = document.querySelectorAll('[data-feather]');
    console.log(
      `Found ${iconElements.length} icon elements with data-feather attributes`,
    );

    iconElements.forEach((element, index) => {
      const iconName = element.getAttribute('data-feather');
      console.log(`Icon ${index + 1}: ${iconName}`);
    });
  } catch (error) {
    console.error('Error initializing Feather icons:', error);
  }
}

// Initialize feather icons on page load and after Turbo navigation
document.addEventListener('DOMContentLoaded', () => {
  initializeFeatherIcons();
});

// Re-initialize icons after Turbo navigation
document.addEventListener('turbo:load', () => {
  initializeFeatherIcons();
});

// Also initialize on turbo:render for dynamic content
document.addEventListener('turbo:render', () => {
  initializeFeatherIcons();
});
